import { MutationTree } from 'vuex'
import State, { ICustomer, ICustomerContact, ICustomerSearchFilter } from './types'
import { ResponseArray } from '../types'
import _ from 'lodash'
import { blankCustomer, blankSalesRepArray, blankSearchFilters } from './constants'

export const mutations: MutationTree<State> = {
  customerLoading(state) {
    state.error = ''
    state.activeCustomer = _.cloneDeep(blankCustomer)
    state.loading = true
  },
  customerLoaded(state, { customer }: { customer: ICustomer }) {
    state.loading = false
    state.activeCustomer = customer
  },
  customerLoadError(state, error: string) {
    state.loading = false
    state.activeCustomer = _.cloneDeep(blankCustomer)
    state.error = error
  },
  customersLoading(state) {
    state.error = ''
    state.customers = blankSalesRepArray
  },
  customersLoaded(state, { customers }: { customers: ResponseArray<ICustomer> }) {
    state.error = ''
    state.customers = customers
  },
  customerShipToLoaded(state, { customers }: { customers: ResponseArray<ICustomer> }) {
    state.error = ''
    state.shipTos = customers
  },
  customersLoadError(state, error: string) {
    state.customers = blankSalesRepArray
    state.error = error
  },
  customerFilterUpdated(state: State, filter: ICustomerSearchFilter) {
    state.searchFilters = { ...state.searchFilters, ...filter }
  },
  customerFilterError(state: State) {
    state.searchFilters = { ...state.searchFilters, ...blankSearchFilters }
  },
  customerClear(state) {
    state.activeCustomer = _.cloneDeep(blankCustomer)
  },
  customerContactsLoaded(state, contacts: ICustomerContact[]) {
    state.error = ''
    state.customerContacts = contacts
  },
}
